import {
  DOORDASH,
  GRUBHUB,
  INSTACART,
  INSTACART_CANADA,
  SHIPT,
  UBER,
  UBER_CANADA,
  CARADVISE,
  UBER_CA,
  USAA
} from "./affiliations"

export const WelcomeModalAffiliations = [
  INSTACART,
  INSTACART_CANADA,
  GRUBHUB,
  SHIPT,
  DOORDASH,
  UBER,
  UBER_CANADA,
  CARADVISE,
  UBER_CA,
  USAA
]
